/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Classifiers_ShortInputs */

const en_advantages_sample_classifiers_short = /** @type {(inputs: Advantages_Sample_Classifiers_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`we use binary cross-entropy loss for the class predictions.`)
};

const es_advantages_sample_classifiers_short = /** @type {(inputs: Advantages_Sample_Classifiers_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`usamos la pérdida de entropía cruzada binaria para las predicciones de clase.`)
};

/**
* | output |
* | --- |
* | "we use binary cross-entropy loss for the class predictions." |
*
* @param {Advantages_Sample_Classifiers_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_classifiers_short = /** @type {((inputs?: Advantages_Sample_Classifiers_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Classifiers_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_classifiers_short(inputs)
	return en_advantages_sample_classifiers_short(inputs)
});